// ── Transporte Tab ────────────────────────────────────────────────────────────
import { getTrip }         from '@/store/tripState';
import { fmt, toArr, fmtR,
         statusBadge, sanitize } from '@/helpers';
import { getPayerName }    from '@/tabs/viagem';
import { attachmentViewerUrl } from '@/ui/attachmentViewer';
import type { Transporte } from '@/types';

export function renderTransporte(): void {
  const el  = document.getElementById('transporte-list');
  if (!el) return;
  const arr = (toArr(getTrip().transporte ?? {}) as Transporte[])
    .sort((a, b) =>
      `${a.data ?? ''}T${a.horaPartida || a.hora || ''}`
        .localeCompare(`${b.data ?? ''}T${b.horaPartida || b.hora || ''}`));
  if (!arr.length) { el.innerHTML = '<div class="empty">Nenhum transporte adicionado.</div>'; return; }

  el.innerHTML = arr.map(t => {
    const payer      = t.pagador ? sanitize(getPayerName(t.pagador)) : '';
    const departure  = t.horaPartida || t.hora || '';
    const departureInfo = [
      t.data ? fmt(t.data) : '',
      departure ? sanitize(departure) : '',
    ].filter(Boolean).join(' às ');
    const arrivalInfo = [
      t.dataChegada ? fmt(t.dataChegada) : '',
      t.horaChegada ? sanitize(t.horaChegada) : '',
    ].filter(Boolean).join(' às ');
    const journeyInfo = [
      departureInfo ? `Partida ${departureInfo}` : '',
      arrivalInfo ? `Chegada ${arrivalInfo}` : '',
    ].filter(Boolean).join(' → ');
    const attachHtml = Object.values(t.attachments ?? {}).map(a =>
      `<a class="attach-chip" href="${attachmentViewerUrl(a)}" target="_blank" rel="noopener noreferrer">📎 ${sanitize(a.name)}</a>`
    ).join('');
    return `
      <div class="card card-row">
        <div style="flex:1;min-width:0">
          <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:4px">
            <span class="card-title">${t.tipo ?? ''} · ${sanitize(t.origem ?? '')}→${sanitize(t.destino ?? '')}</span>
            ${statusBadge(t.status ?? '')}
          </div>
          <div class="card-sub">
            ${journeyInfo || 'Datas e horários não informados'}
            ${t.operadora ? ' · ' + sanitize(t.operadora) : ''}${t.num ? ' ' + sanitize(t.num) : ''}
          </div>
          ${t.preco ? `<div class="card-sub">${fmtR(t.preco)}${payer ? ' · Pago por ' + payer : ''}</div>` : ''}
          ${attachHtml ? `<div class="attach-list">${attachHtml}</div>` : ''}
        </div>
        <div class="card-actions">
          <button class="icon-btn" onclick="window.__openAttachModal('transporte','${t.id}')">📎</button>
          <button class="icon-btn" onclick="window.__openModal('transporte','${t.id}')">✏</button>
          <button class="icon-btn del" onclick="window.__delItem('transporte','${t.id}')">×</button>
        </div>
      </div>`;
  }).join('');
}
